export default __webpack_public_path__ + "static/payment-cards-banner-2abeeadfb998afdcea14b7964e4da574.png";